import React from 'react'
import NavLinkContainer from 'redux/containers/components/layout/mobile-menu/NavLinkContainer'
import NavFileContainer from 'redux/containers/components/layout/mobile-menu/NavFileContainer'

const NavItem = (props) => {
  switch (props.type) {
    case 'file':
      return <NavFileContainer {...props} />
    case 'link':
    default:
      return <NavLinkContainer {...props} />
  }
}

export default NavItem
